"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var urlRegExp = /http(s*)?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g;
var checkLinkIsOuterLink = function (linkHref) {
    if (linkHref && linkHref.match(urlRegExp)) {
        return true;
    }
    return false;
};
exports.default = checkLinkIsOuterLink;
